













































































































import {Component, Prop, Vue} from "vue-property-decorator";

@Component({ name: "link-tools-french-links" })
export default class LinkToolsFrenchLinks extends Vue {
  @Prop({ required: true }) links: object;

  async beforeMount() {
    this.$route.meta.title = this.$t("links.title");
  }
}
